export const PRE_SELL_CODE = 4;
export const FLASH_SALE = 1;

